<atl-ngb-modal-header class="configure-builder-modal__header" 
    (closeModalEvent)="closeModal()" 
     [isClient]="false"
     [title]="'Title.Save_showroom'">
 </atl-ngb-modal-header>

<div class="d-flex download-modal__content v-scrollbar flex-column">
    <div class="p-24">
        <p class="fz-16 lh-24">
            {{'Description.Type_email_design' | translate}}
        </p>

        <form class="mt-24" [formGroup]="form">
            <atl-input
              [placeholder]="'Input.Enter_Email.Placeholder'"
              formControlName="email"
              [label]="'Input.Email.Label'"
              [isBlurChange]="true"
          ></atl-input>
        </form>
    </div>
</div>

<footer class="download-modal__footer">
    <div class="d-flex align-items-center justify-content-end h-100">
        <div class="d-flex">
            <button (click)="confirm()" class="newest-button newest-button-spinner fz-16 fw-500" 
              [disabled]="form?.invalid">
                {{ 'Title.Send_to_email' | translate }}
            </button>
        </div>
    </div>
</footer>